import React from 'react'
import clsx from 'clsx'
import BasePhoneInput from 'react-phone-input-2'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import FieldCopy from '../FieldCopy'

import { getFormatted } from '@SonarCX/utilities/phoneNumber'
import useBaseStyles from '../styles'
import useStyles from './styles'

type PhoneInputProps = {
  field: LocalCustomField
  value: string
  handleChange: (
    e: any,
    field: LocalCustomField,
    row?: number,
    rowKey?: string,
    parent?: APICustomField
  ) => void
  handleBlur?: () => void
  disabled?: boolean
  canEdit?: boolean
  task?: boolean
  inputOnly?: boolean
  row?: number
  rowKey?: string
  parent?: APICustomField
  inTable?: boolean
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  field,
  value,
  handleChange,
  handleBlur,
  disabled,
  canEdit,
  task,
  inputOnly,
  row,
  rowKey,
  parent,
  inTable
}) => {
  const [startingValue, setStartingValue] = React.useState('')
  const [hovering, setHovering] = React.useState(false)

  const baseClasses = useBaseStyles({
    readOnly: disabled,
    canEdit,
    task,
    inputOnly,
    inTable
  })
  const classes = useStyles()

  const getLocale = React.useCallback(() => {
    try {
      const lang = navigator.language.split('-')[1]
      return lang.toLowerCase()
    } catch (error) {
      console.warn('Could not get browser locale, using fallback')
      return 'us'
    }
  }, [])

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(
        baseClasses.fieldInputRoot,
        classes.root,
        'cf-input-root'
      )}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(baseClasses.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <FieldCopy
        inTable={inTable}
        visible={hovering}
        text={getFormatted(value)}
      />

      <div className={baseClasses.input}>
        <BasePhoneInput
          placeholder='Phone Number'
          value={value}
          disableSearchIcon
          disableDropdown
          prefix=''
          country={getLocale()}
          onChange={value =>
            handleChange({ target: { value } }, field, row, rowKey, parent)
          }
          onFocus={() => setStartingValue(value)}
          onBlur={e => {
            if (e.target.value !== startingValue) {
              handleBlur && handleBlur()
            }
          }}
        />
      </div>
    </div>
  )
}

export default PhoneInput
